<template>
  <v-menu
    v-if="header.text"
    v-model="menuOpen"
    :close-on-content-click="false"
    nudge-bottom="14"
    nudge-left="12"
    offset-y
  >
    <template #activator="{ on }">
      <v-hover v-slot="{ hover }">
        <span
          class="column-header"
          :data-cy="`${header.text}-dropdown`"
          v-on="on"
        >
          {{ header.text }}
          <v-icon
            v-if="showFilterIcon"
            color="$snBrand03"
          >
            $snFilters2
          </v-icon>
          <v-icon
            v-if="showSortIcon"
            color="$snBrand03"
          >
            {{ sortIcon }}
          </v-icon>
          <v-icon :color="(hover || menuOpen) ? '$snPrimary03' : 'transparent'">
            {{ headerIcon }}
          </v-icon>
        </span>
      </v-hover>
    </template>

    <sort-and-filter-menu
      :sort-by-options="header.sortBy"
      :active-sort="activeSort"
      :filter-options="header.filterBy"
      :cy-tag="header.value"
      @filters:change="applyChanges"
      @filters:search="searchFilters"
      @filters:load-more="$emit('header-filters:load-more', header.value)"
    />
  </v-menu>
</template>

<script>
import SortAndFilterMenu from './menu.vue'

export default {
  name: 'SortAndFilterHeader',
  components: { SortAndFilterMenu },
  props: {
    header: {
      type: Object,
      required: true
    },
    activeSort: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      menuOpen: false
    }
  },
  computed: {
    showFilterIcon () {
      const nodes = this.header.filterBy?.nodes ?? this.header.filterBy
      if (!nodes) return false
      return nodes.some(f => f.active)
    },
    sortByKey () {
      const sortByOptions = this.header.sortBy
      if (!sortByOptions || sortByOptions.length === 0) return ''
      const sortByValue = sortByOptions[0].value
      return sortByValue.split(' ')[0]
    },
    showSortIcon () {
      return !this.showFilterIcon && this.activeSort && this.activeSort.split(' ')[0] === this.sortByKey
    },
    sortIcon () {
      if (!this.showSortIcon || !this.activeSort) return null
      const sortDir = this.activeSort.split(' ')[1]
      return sortDir === 'ASC' ? '$snArrowDown' : '$snArrowUp'
    },
    filterIcon () {
      return this.sn_snTableFilterMixin_hasFilter ? '$snFilters2' : ''
    },
    headerIcon () {
      return this.menuOpen ? '$snChevronUp' : '$snChevronDown'
    }
  },
  methods: {
    applyChanges (changes) {
      this.menuOpen = false

      if (changes.sortBy) {
        this.$emit('header-sort:change', changes.sortBy)
      }

      if (changes.filters) {
        changes.filters = {
          col: this.header.value,
          filters: changes.filters
        }

        this.$emit('header-filters:change', changes.filters)
      }
    },
    searchFilters (search) {
      this.$emit('header-filters:search', {
        col: this.header.value,
        searchValue: search
      })
    }
  }
}

</script>
<style lang="scss" scoped>
.column-header {
  min-height: 24px;
  cursor: pointer;
}

.flip {
  transform: rotate(180deg)
}
</style>
